import type { EngineDocument } from "../scene/model";
import { isInteractive } from "../native/interactive";
import { textData } from "../native/text";

/** Package the existing editor font faces; exported materials do not depend on the editor host. */
export async function exportFontAssets(
  scene: EngineDocument,
  assets: Map<string, Blob>,
) {
  const families = new Set(
    scene.pages
      .flatMap((p) => p.nodes)
      .flatMap((n) =>
        isInteractive(n)
          ? [String(n.interaction.fontFamily)]
          : n.kind === "text" && n.interaction.dynamicTextType
            ? [textData(n).family]
            : [],
      ),
  );
  const css: string[] = [],
    files = new Map<string, string>();
  for (const sheet of globalThis.document.styleSheets) {
    if (!sheet.href || new URL(sheet.href).origin !== location.origin) continue;
    for (const rule of sheet.cssRules) {
      if (!(rule instanceof CSSFontFaceRule)) continue;
      const family = rule.style
        .getPropertyValue("font-family")
        .replace(/^["']|["']$/g, "");
      if (!families.has(family)) continue;
      let source = rule.style.getPropertyValue("src");
      for (const match of [...source.matchAll(/url\(["']?([^"')]+)["']?\)/g)]) {
        const url = new URL(match[1]!, sheet.href).href;
        let path = files.get(url);
        if (!path) {
          const response = await fetch(url);
          if (!response.ok)
            throw new Error(`Не удалось включить шрифт «${family}» в экспорт.`);
          path = `fonts/font-${files.size + 1}.woff2`;
          assets.set(path, await response.blob());
          files.set(url, path);
        }
        source = source.replace(match[0], `url("${path}")`);
      }
      css.push(
        `@font-face{font-family:${JSON.stringify(family)};src:${source};font-weight:${rule.style.getPropertyValue("font-weight") || "normal"};font-style:${rule.style.getPropertyValue("font-style") || "normal"};font-display:block;}`,
      );
    }
  }
  return css.join("\n");
}
